import { render, staticRenderFns } from "./PracticeFeeEditRates.vue?vue&type=template&id=2102c6f2&scoped=true&"
import script from "./PracticeFeeEditRates.vue?vue&type=script&lang=js&"
export * from "./PracticeFeeEditRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2102c6f2",
  null
  
)

export default component.exports